export default "__VITE_ASSET__JLV1lpnv__"